import { ref } from "vue";
import { useRouter } from "vue-router/auto";
import { useGameStore } from "@/stores/game";
import { useLobbyStore } from "@/stores/lobby";
import { useToastStore } from "@/stores/toast";

/** The target scores a table can play to, shortest first. */
export const GAME_LENGTHS = [
	{ points: 38, label: "Quick" },
	{ points: 76, label: "Standard" },
	{ points: 151, label: "Full" }
] as const;

/** Starts a game with bots or opens a new table: what the Play dock and Home's Play panel offer. */
export function usePlay() {
	const lobby = useLobbyStore();
	const game = useGameStore();
	const toast = useToastStore();
	const router = useRouter();
	const busy = ref<"bots" | "table">();

	/** Resolves true when the player now has a table to go to, even after a partial failure. */
	async function start(kind: "bots" | "table", points?: number) {
		if (busy.value || game.myUuid || lobby.lobbyID > 0) return false;
		busy.value = kind;
		try {
			if (kind === "bots") await lobby.veryQuickGame(points);
			else await lobby.createLobby();
			await router.push("/");
			return true;
		} catch (error) {
			toast.error(error instanceof Error ? error.message : "Cannot start a game. Please try again.");
			if (lobby.lobbyID > 0) {
				await router.push("/");
				return true;
			}
			return false;
		} finally {
			busy.value = undefined;
		}
	}

	return { busy, start };
}
